import { Pipe, PipeTransform } from '@angular/core';
import { Invoice } from '../domain/registrator';

@Pipe({
  name: 'invoiceListFormatter',
  standalone: true
})
export class InvoiceListFormatterPipe implements PipeTransform {

  transform(invoice: Invoice): string {
    if (!invoice) {
      return 'No invoice issued';
    }
    const dateFormatter = new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
    return `${invoice.number} (${dateFormatter.format(new Date(invoice.date))})`;

    // return invoices
    //   .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime() || (- a.type.localeCompare(b.type)))
    //   .map(invoice => `${invoice.number} (${dateFormatter.format(new Date(invoice.date))})`)
    //   .join(', ');
  }

}
